module.exports = __webpack_public_path__ + "img/abstract-shapes-8.ee24b9bb.svg";